import { useEffect, useLayoutEffect, useRef } from 'react';

const MESSAGE_SCROLL_BOTTOM_THRESHOLD = 24;

export function useDiscoveryMessageAutoScroll(latestMessageId: string | undefined) {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const wasNearBottomRef = useRef(true);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    const syncNearBottom = () => {
      wasNearBottomRef.current = isNearScrollBottom(scrollContainer);
    };

    syncNearBottom();
    scrollContainer.addEventListener('scroll', syncNearBottom, { passive: true });

    return () => {
      scrollContainer.removeEventListener('scroll', syncNearBottom);
    };
  }, []);

  useLayoutEffect(() => {
    if (!latestMessageId || !wasNearBottomRef.current) return;

    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    const animationFrame = requestAnimationFrame(() => {
      scrollContainer.scrollTo({
        top: getScrollBottomTop(scrollContainer),
      });
      wasNearBottomRef.current = true;
    });

    return () => {
      cancelAnimationFrame(animationFrame);
    };
  }, [latestMessageId]);

  return scrollContainerRef;
}

function isNearScrollBottom(viewport: HTMLElement) {
  return getScrollBottomTop(viewport) - viewport.scrollTop <= MESSAGE_SCROLL_BOTTOM_THRESHOLD;
}

function getScrollBottomTop(viewport: HTMLElement) {
  return Math.max(0, viewport.scrollHeight - viewport.clientHeight);
}
